import { render, staticRenderFns } from "./aStaffDetailList.vue?vue&type=template&id=e8fa1260&scoped=true"
import script from "./aStaffDetailList.vue?vue&type=script&lang=js"
export * from "./aStaffDetailList.vue?vue&type=script&lang=js"
import style0 from "./aStaffDetailList.vue?vue&type=style&index=0&id=e8fa1260&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8fa1260",
  null
  
)

export default component.exports